import { useEffect, useState } from "react";
import { Modal } from "../ui/modal";
import { Button } from "../ui/button";
import { ComplaintsType } from "@/src/data/types";

interface InformationModalProps {
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
  complaintData?: ComplaintsType | null;
}

export const InformationModal: React.FC<InformationModalProps> = ({
  isOpen,
  onClose,
  loading,
  complaintData,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Modal
      title="Détails du message"
      description={`Message envoyé par Mr/Mme : ${
        complaintData?.firstName
      } le ${
        complaintData?.createdAt
          ? new Date(complaintData.createdAt).toLocaleDateString("fr-FR")
          : "Date inconnue"
      }`}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div>
        {complaintData && (
          <p>
            <p className="font-bold">
              Email : <span className="font-normal">{complaintData.email}</span>{" "}
            </p>
            <span className="font-bold">
              Societé :{" "}
              <span className="font-normal">{complaintData.company} </span>
            </span>
            <p className="font-bold">
              Message:{" "}
              <span className="font-normal">{complaintData.message}</span>{" "}
            </p>{" "}
          </p>
        )}
      </div>
      <div className="flex items-center justify-end w-full pt-6 space-x-2">
        <Button disabled={loading} onClick={onClose}>
          Quitter
        </Button>
      </div>
    </Modal>
  );
};
